import React from 'react';

export function Tabs({ value, onValueChange, children }) {
    return (
        <div className="w-full">
            {children}
        </div>
    );
}

export function TabsList({ children, className = '' }) {
    return (
        <div className={`border-b border-gray-200 ${className}`}>
            <nav className="-mb-px flex">
                {children}
            </nav>
        </div>
    );
}

export function TabsTrigger({ value, activeValue, onValueChange, children, className = '' }) {
    const isActive = value === activeValue;
    
    return (
        <button
            type="button"
            onClick={() => onValueChange(value)}
            className={`py-4 px-4 border-b-2 font-medium text-sm uppercase tracking-wide transition-colors ${className} ${
                isActive
                    ? 'border-primary-500 text-primary-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            }`}
        >
            {children}
        </button>
    );
}

export function TabsContent({ value, activeValue, children, className = '' }) {
    if (value !== activeValue) {
        return null;
    }
    
    return (
        <div className={className}>
            {children}
        </div>
    );
}

